import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    declarations: [],
    imports: [CommonModule, HttpClientModule],
})
export class IconRegistryModule {
    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {

        /**
         * Each and every custom icon should be registered here
         * and must follow "mwo-" prefix.
         * Each active set of icon muse be registered with the suffix "_active"
         */
        this.matIconRegistry.addSvgIcon(
            'mwo-dislike',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_dislike.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-dislike_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_dislike_active.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mwo-like',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_like.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-like_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_like_active.svg')
        );


        this.matIconRegistry.addSvgIcon(
            'mwo-speaker',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_speaker.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-speaker_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_speaker_active.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mwo-volume',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_volume.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-volume_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_volume_active.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mwo-playback',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_playback.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-playback_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_playback_active.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mwo-next',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_next.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-next_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_next_active.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mwo-help',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_help.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-help_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_help_active.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mwo-settings',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_settings.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-settings_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_settings_active.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mwo-swap_horiz',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_swap_horiz.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-swap_horiz_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_swap_horiz_active.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mwo-mark',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_mark.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mwo-mark_active',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mwo_mark_active.svg')
        );

        this.matIconRegistry.setDefaultFontSetClass('material-icons-outlined');

    }
}